'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('complaint', {
        url: '/complaint',
        template: '<complaint></complaint>'
    });
}



// WEBPACK FOOTER //
// ./client/app/complaint/complaint.routes.js